function toggleMenu(){document.getElementById('mobileNav').classList.toggle('open')}
function closeMenu(){document.getElementById('mobileNav').classList.remove('open')}
document.addEventListener('click',function(e){
  var nav=document.getElementById('mobileNav'),burger=document.querySelector('.burger');
  if(nav&&nav.classList.contains('open')&&!nav.contains(e.target)&&burger&&!burger.contains(e.target))nav.classList.remove('open')
});
function toggleLegalNotice(e){
  e.preventDefault();
  var m=document.getElementById('legal-notice-modal');
  if(m)m.style.display=m.style.display==='none'||m.style.display===''?'block':'none';
}
async function submitVauForm(e,id){
  e.preventDefault();
  var f=e.target,btn=f.querySelector('[type=submit]'),
      ok=document.getElementById(id+'-success'),
      er=document.getElementById(id+'-error'),
      t=btn.innerHTML;
  if(er)er.style.display='none';
  if(ok)ok.style.display='none';
  btn.disabled=true;btn.innerHTML='Відправляємо…';
  try{
    var r=await fetch('/contact',{
      method:'POST',
      credentials:'include',
      headers:{'Content-Type':'application/x-www-form-urlencoded','X-Requested-With':'XMLHttpRequest'},
      body:new URLSearchParams(new FormData(f)).toString()
    });
    if(r.status<500){
      if(ok)ok.style.display='block';
      f.style.cssText='opacity:.3;pointer-events:none';
      btn.innerHTML='✓ Надіслано';
    }else throw new Error('HTTP '+r.status);
  }catch(x){
    if(x&&x.name==='AbortError'){
      if(ok)ok.style.display='block';
      f.style.cssText='opacity:.3;pointer-events:none';
      btn.innerHTML='✓ Надіслано';
    }else{
      console.error('VAU form error:',x);
      if(er)er.style.display='block';
      btn.disabled=false;btn.innerHTML=t;
    }
  }
}
document.addEventListener('DOMContentLoaded',function(){
  ['legal','media','join'].forEach(function(id){
    var f=document.getElementById(id+'-form');
    if(f)f.addEventListener('submit',function(e){submitVauForm(e,id)});
  });
});
